module.exports = __webpack_public_path__ + "static/media/09-shop-index.e6c58553.png";